module.exports = __webpack_public_path__ + "img/image7.fdc52540.jpg";